import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConsentUiService {
  private readonly openSubject = new Subject<void>();
  readonly open$ = this.openSubject.asObservable();

  openPreferences(): void {
    this.openSubject.next();
  }
}
